import { CustomAffichage, ProprieteAffichee, TypePropriete } from "./proprieteAffichee";
import { Site } from "./site";


export class ControlPoint {
  controlPointId: number;
  siteId: number;
  numeroPoint: number;
  name: string;
  site: Site;
  x: number;
  y: number;
  z: number;
  ppv:number;
  k:number;
  alpha:number;
  isActif: boolean = true;

  getProprietesAffichees() {
    let tab: ProprieteAffichee[] = [];
    tab.push(new ProprieteAffichee('isActif', 'GLOBAL.ACTIF', '',
      new CustomAffichage(TypePropriete.Boolean, 'fas fa-check-circle checkbox-epc-green', 'fas fa-minus-circle checkbox-epc-red')));
    tab.push(new ProprieteAffichee('numeroPoint', 'CONTROL_POINT.NUMERO_PT_CONTROL'));
    tab.push(new ProprieteAffichee('name', 'GLOBAL.NOM'));
    
    tab.push(new ProprieteAffichee('x', 'EPSG.X'));
    tab.push(new ProprieteAffichee('y', 'EPSG.Y'));
    tab.push(new ProprieteAffichee('z', 'EPSG.Z'));

    tab.push(new ProprieteAffichee('ppv', 'CONTROL_POINT.PPV'));
    tab.push(new ProprieteAffichee('k', 'CONTROL_POINT.K'));
    tab.push(new ProprieteAffichee('alpha', 'CONTROL_POINT.ALPHA'));

    return tab;
  }




}


  export class ControlPointVib{
    controlPointId: number
    vibrationType: VibrationType
    constructor(
      controlPointId: number,
      private readonly siteId: number,
      private readonly numeroPoint: number,
      public name: string,
      private readonly site: Site,
      private readonly x: number,
      private readonly y: number,
      private readonly z: number,
      vibrationType: VibrationType,
    ){
      this.controlPointId = controlPointId
      this.vibrationType = vibrationType
    }
  }



export enum VibrationType{
  OLD = 1,
  NEW = 2
}